module.exports = __webpack_public_path__ + "img/Down.5164cb93.jpg";